import React from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';


ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);




export default function BarChart({ labels, dataSet, label,title="",color="green" }) {
     const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
            },
            title: {
                display: true,
                text: title,
            },
            
        },
        
    };
    // const labels = ['January', 'February', 'March', 'April', 'May', 'June', 'July'];
    const data = {
        labels,
        datasets: [
            {
                label,//: 'Dataset 1',
                data: dataSet,// [200,300,40,50,16,7000,1000,100000],
                backgroundColor: color//'rgba(255, 99, 132, 0.5)',
                
            },
            // {
            //   label: 'Dataset 2',
            //   data: labels.map(() => faker.datatype.number({ min: 0, max: 1000 })),
            //   backgroundColor: 'rgba(53, 162, 235, 0.5)',
            // },
        ],
    };
    return <Bar style={{minHeight:300}} options={options} data={data} />;
}
